import React, { FC } from 'react';
import { SettingsFormPageSkeleton } from '../settings/settingsSkeleton';

export const GeneralSettingsConfiguratorPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
